import {
  AutocompleteLabelField,
  InputField,
  SelectField,
} from "@/features/FormCard/Fields";
import { useFeesCalculator } from "@/hooks/useFeesCalculator";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

type SecuritiesContentProps = {
  form: UseFormReturn<FieldValues>;
  currencyOptions: any[];
};

export function SecuritiesFeeContent({
  form,
  currencyOptions,
}: SecuritiesContentProps) {
  useFeesCalculator(form);
  const { t } = useTranslation();

  return (
    <div className="py-3">
      <div className="mb-2">
        <div className="text-xs">
          {t("transactions.securities_transaction_fees", {
            defaultValue: "Securities transaction fees",
          })}
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <AutocompleteLabelField
            name="fee_currency"
            label={t("a6_transactions.columns.fee_currency", {
              ns: "tables",
              defaultValue: "Fee currency",
            })}
            control={form.control}
            options={currencyOptions}
          />
          <InputField
            name="broker_fee"
            label={t("a6_transactions.columns.broker_fee", {
              ns: "tables",
              defaultValue: "Broker fee",
            })}
            control={form.control}
            type="number"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InputField
            name="custodian_broker_fee"
            label={t("a6_transactions.columns.custodian_broker_fee", {
              ns: "tables",
              defaultValue: "Custodian broker fee",
            })}
            control={form.control}
            type="number"
          />
          <InputField
            name="other_fee"
            label={t("a6_transactions.columns.other_fee", {
              ns: "tables",
              defaultValue: "Other fee",
            })}
            control={form.control}
            type="number"
          />
        </div>
        <InputField
          name="fees"
          label={t("a6_transactions.columns.fees", {
            ns: "tables",
            defaultValue: "Total fees",
          })}
          control={form.control}
          type="number"
        />
      </div>
    </div>
  );
}

type CashContentProps = {
  form: UseFormReturn<FieldValues>;
  isDisabled: boolean;
  feeOptionsTranslation?: {
    [key: string]: string;
  };
};

export function CashFeeContent({
  form,
  isDisabled,
  feeOptionsTranslation,
}: CashContentProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-2">
      <SelectField
        name="fee_type"
        label={t("a6_transactions.columns.fee_type", {
          ns: "tables",
          defaultValue: "Fee type",
        })}
        control={form.control}
        options={feeOptionsTranslation}
        allow_empty_option={!isDisabled}
        fieldOptions={{
          isDisabled: isDisabled,
        }}
      />
    </div>
  );
}
